import React, { useRef, useEffect, useState } from 'react';
import {
  Content,
  Row,
  Col,
  Title,
  Text,
  Button,
  Pagination,
  Pre,
} from 'components';
import { SideMenu } from 'routes/main.routes/Mypage/components';
import more from 'assets/more.svg';
import { Empty, Input, Spin } from 'antd';
import search from 'assets/search.svg';
import { csMenu } from '../csMenu';

const PAGE_SIZE = 10;

const HelpQuestionsPresenter = (props) => {
  /* ===== Props ===== */
  const {
    tapItem,
    tap,
    expandedQuestion,
    currentPage,
    setCurrentPage,
    FAQ,
    navigate,
    onTapChange,
    onToggleQuestion,
    onNavigate,
    screenSize,
  } = props;

  /* ===== State ===== */
  // Tap별 FAQ 목록
  const [faqList, setFaqList] = React.useState(FAQ);
  // 검색된 FAQ 목록
  const [searchList, setSearchList] = React.useState([]);
  // 검색어
  const [inputValue, setInputValue] = React.useState('');
  // 로딩
  const [isLoading, setIsLoading] = React.useState(false);
  //답변 높이
  const [answerHeights, setAnswerHeights] = useState({}); // 각 답변의 높이 저장

  /* ===== Refs ===== */
  const answerRefs = useRef({}); // 각 질문별 ref 저장

  useEffect(() => {
    const newHeights = {};
    Object.keys(answerRefs.current).forEach((id) => {
      if (answerRefs.current[id]) {
        newHeights[id] = answerRefs.current[id].scrollHeight; // 각 답변 요소의 실제 높이 저장
      }
    });
    setAnswerHeights(newHeights);
  }, [searchList, expandedQuestion]); // expandedQuestion이 변경될 때마다 업데이트

  /* ===== Function ===== */
  /**
   * FAQ 검색
   * --
   */
  const handleSearch = () => {
    setIsLoading(true);

    const searchList = faqList.filter((faq) => faq.title.includes(inputValue));

    setTimeout(() => {
      setIsLoading(false);
      setSearchList(searchList);
    }, 500);
  };

  /* ===== Variables ===== */
  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 24,
      borderBottom: '2px solid var(--black-color)',
    },
    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
    },
    button: {
      padding:
        screenSize >= 768
          ? '10px 29px'
          : screenSize >= 500
          ? '8px 18px'
          : '6px 16px',
      borderRadius: '2px',
      backgroundColor: 'transparent',
      border: '1px solid var(--dark-gray-color)',
      color: 'var(--black-color)',
      fontSize: screenSize >= 500 ? 16 : 14,
    },
    tap: {
      padding:
        screenSize >= 768
          ? '10px 29px'
          : screenSize >= 500
          ? '8px 18px'
          : '6px 16px',
      borderRadius: '2px',
      backgroundColor: 'var(--black-color)',
      color: 'white',
      fontSize: screenSize >= 500 ? 16 : 14,
    },
    question: {
      padding: '32px 0',
      borderBottom: '1px solid var(--light-gray-color)',
      cursor: 'pointer',
      fontSize: screenSize >= 500 ? 16 : 15,
    },
    answerContainer: {
      overflow: 'hidden',
      transition: 'max-height 0.3s ease',
      maxHeight: '0',
    },
    answer: {
      backgroundColor: '#f8f8f8',
      padding: '32px',
      marginTop: '20px',
      color: '#444',
      fontSize: screenSize >= 500 ? 16 : 15,
      wordBreak: 'keep-all',
    },
    expanded: (id) => ({
      maxHeight: answerHeights[id] ? `${answerHeights[id]}px` : '0',
    }),
  };

  /* ===== Hooks ===== */
  /**
   * 탭별 FAQ 목록 정제
   * --
   */
  React.useEffect(() => {
    const filterList = FAQ.filter((faq) =>
      tap === 'ALL' ? true : faq.status === tap
    );

    setFaqList(filterList);
    setSearchList(filterList);
  }, [FAQ, tap]);

  /* ===== Render ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px' : '80px 0'}
        >
          <Row gutter={25}>
            <Col x={0} md={2}></Col>
            <Col x={0} md={4}>
              <SideMenu menu={csMenu} title="고객센터" />
            </Col>
            <Col x={24} md={16}>
              <Content
                maxWidth={'100%'}
                padding={screenSize >= 768 ? '0 0 0 95px' : '0'}
              >
                <div style={styles.titleLayout}>
                  <Title style={styles.title}>FAQ</Title>
                </div>

                <div
                  style={{
                    margin: screenSize >= 768 ? '32px 0' : '20px 0',
                    display: 'flex',
                    gap: screenSize >= 768 ? 16 : 10,
                    flexDirection: screenSize >= 768 ? 'unset' : 'column',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: screenSize >= 768 ? 12 : 6,
                    }}
                  >
                    {tapItem.map((tab) => (
                      <Button
                        key={tab.value}
                        style={tap === tab.value ? styles.tap : styles.button}
                        onClick={() => onTapChange(tab.value)}
                      >
                        {tab.label}
                      </Button>
                    ))}
                  </div>
                  <div
                    style={{
                      position: 'relative',
                      width: screenSize >= 768 ? '35%' : '100%',
                      height: screenSize >= 768 ? 50 : 40,
                      marginLeft: 'auto',
                    }}
                  >
                    <Input
                      style={{ width: '100%', height: '100%' }}
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      onPressEnter={() => handleSearch()}
                    />
                    <img
                      src={search}
                      alt="search icon"
                      style={{
                        cursor: 'pointer',
                        position: 'absolute',
                        top: '50%',
                        right: '20px',
                        transform: 'translateY(-50%)',
                      }}
                      onClick={() => handleSearch()}
                    />
                  </div>
                </div>

                <div
                  style={{ ...styles.titleLayout, justifyContent: 'flex-end' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      cursor: 'pointer',
                    }}
                    onClick={() => onNavigate()}
                  >
                    <Text
                      style={{
                        marginLeft: 'auto',
                        cursor: 'pointer',
                        fontSize: screenSize >= 768 ? 16 : 14,
                      }}
                    >
                      1:1 문의하기
                    </Text>
                    <img
                      src={more}
                      alt="more icon"
                      style={{ cursor: 'pointer' }}
                      onClick={() => navigate('/cs/inquire')}
                    />
                  </div>
                </div>

                {/* {(() => {
                  console.log('searchList: ', searchList);
                })()} */}
                <Content maxWidth={'100%'} padding={0}>
                  {searchList.length ? (
                    searchList
                      .slice(
                        (currentPage - 1) * PAGE_SIZE,
                        currentPage * PAGE_SIZE
                      )
                      .map((question) => (
                        <div key={question.id} style={styles.question}>
                          <div
                            onClick={() => onToggleQuestion(question.id)}
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              wordBreak: 'keep-all',
                            }}
                          >
                            <span
                              style={{
                                backgroundColor: 'var(--black-color)',
                                color: 'var(--white-color)',
                                padding: '4px 8px',
                                marginBottom: '8px',
                                width: 'fit-content',
                                fontSize: screenSize >= 500 ? 14 : 13,
                              }}
                            >
                              {question.status}
                            </span>
                            <Pre children={question.title}></Pre>
                            {/* <div
                              dangerouslySetInnerHTML={{
                                __html: question.title,
                              }}
                            /> */}
                          </div>
                          <div
                            ref={(el) => (answerRefs.current[question.id] = el)}
                            style={{
                              ...styles.answerContainer,
                              ...(expandedQuestion === question.id
                                ? styles.expanded(question.id)
                                : {}),
                            }}
                          >
                            <Pre
                              style={styles.answer}
                              children={question.answer}
                            ></Pre>
                            {/* <div
                              style={styles.answer}
                              dangerouslySetInnerHTML={{
                                __html: question?.answer,
                              }}
                            /> */}
                          </div>
                        </div>
                      ))
                  ) : (
                    <div style={{ marginTop: 30 }}>
                      <Empty description={'등록된 게시물이 없습니다.'} />
                    </div>
                  )}
                </Content>

                <div style={{ marginTop: 100 }}>
                  <Pagination
                    total={searchList.length}
                    pageSize={PAGE_SIZE}
                    showPage={5}
                    current={currentPage}
                    onChange={(page) => setCurrentPage(page)}
                    buttonStyle={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: '#999999',
                      background: 'none',
                      width: 28,
                      height: 28,
                    }}
                    isButton={true}
                    activeStyle={{
                      color: `var(--black-color) !important`,
                      borderBottom: '2px solid #111111',
                    }}
                    hoverStyle={{
                      color: `var(--black-color) !important`,
                    }}
                    navStyle={{
                      border: '1px solid var(--black-color)',
                    }}
                    isLatestButton={true}
                  />
                </div>
              </Content>
            </Col>
            <Col x={0} md={2}></Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default HelpQuestionsPresenter;
